import type { Order } from 'types'
import type { PlanInterval } from 'types/plan'
import api from 'lib/api'

export function fetchOneByActivationCode(activationCode: string) {
  return api
    .get<{ data: Order }>('/api/v2/orders', { params: { activationCode } })
    .then(({ data }) => data.data)
}

export type ActivateInputUser = {
  firstName: string
  lastName: string
  email: string
  phone: string
  password: string
  confirmPassword: string
}

export type ActivateInput = ActivateInputUser & {
  activationCode: string
  planInterval: PlanInterval
  payment: {
    zip?: string
    token: string
  }
  policyAcceptance: boolean
  smsPermission: boolean
  saveCard: boolean
}


export function activate(data: ActivateInput) {
  return api
    .post<{ data: Order }>('/api/v2/orders/activate', { data })
    .then(({ data }) => data.data)
}

export type LookupOrderParams = {
  firstName?: string
  lastName?: string
  phone?: string
  orderNumber?: string
}

export function lookupOrder(params: LookupOrderParams) {
  return api
    .get<{ data: Order }>('/api/v2/orders/lookup', { params })
    .then(({ data }) => data.data)
}

export type AccountInput = {
  promoCode: string
  firstName: string
  lastName: string
  email: string
  phone: string
  password: string
  confirmPassword: string
}

export type PlanInput = {
  planInterval: PlanInterval
}

export type IntellitagsInput = {
  intellitagOrderItems: {
    size: 'small' | 'medium' | 'large'
    type: string
    weight: string
    name: string
    phone: string
    engraving: string
  }[]
}

export type ShippingInput = {
  address: string
  address2?: string
  city: string
  country: string
  state: string
  zip: string
  phone: string
}

export type CheckoutInput = AccountInput &
  PlanInput & { order: IntellitagsInput } & {
    shippingAddress: ShippingInput
  } & {
    payment: {
      zip: string
      token: string
    }
  }

export function checkout(data: CheckoutInput) {
  return api
    .post<{ data: Order }>('/api/v2/orders/checkout', { data })
    .then(({ data }) => data.data)
}
